/**
 * English locale dictionary.
 * Keys are flat strings; values are display strings (may contain {{placeholder}} for interpolation).
 */
export const en: Record<string, string> = {
  // HUD
  "hud.mana": "LIGHT (LIFE)",
  "hud.tempo": "TEMPO",
  "hud.blessing": "BLESSING",
  "hud.pressSpace": "Press Space to begin",
  "hud.chapelCost": "Chapel: {{cost}} light",
  "hud.wallCost": "Wall: {{cost}} light",
  "hud.amplifierCost": "Amp: {{cost}} light",
  "hud.trapCost": "Trap: {{cost}} light",
  "hud.modeAmp": "Amplifier",
  "hud.modeTrap": "Trap",
  "hud.relicCost": "Relic: {{cost}} light",
  "hud.shrineCost": "Shrine: {{cost}} light",
  "hud.modeShrine": "Shrine",
  "hud.modeLabel": "Mode [W/A/T/R]:",
  "hud.modeTower": "Chapel",
  "hud.modeWall": "Wall",
  "hud.horde": "HORDE",
  "hud.spawned": "{{spawned}}/{{total}} spawned",
  "hud.next": "Next:",
  "hud.mobType.Normal": "Devils",
  "hud.mobType.Swarm": "Imps",
  "hud.mobType.Armored": "Fell Knights",
  "hud.mobType.Giant": "Dark Lords",
  "hud.mobType.Runner": "Wraiths",
  "hud.nextDetails": "{{count}}× HP {{hp}}",
  "hud.hint.clickGround": "Click ground: build chapel",
  "hud.hint.keys": "Keys 1-8: invoke relic",
  "hud.hint.clickChapel": "Click chapel: install relic",
  "hud.hint.sanctify": "U: sanctify  D: replicate  C: combine",
  "hud.hint.meltdown": "X: melt down  Space: begin horde",
  "hud.inventory": "Relics:",
  "hud.noRelics": "No relics (press 1-8 to invoke)",
  "hud.hint.bomb": "Drag relic onto field — AoE bomb",
  // DOM HUD — new keys Phase 2
  "hud.settings": "Settings",
  "battleMenu.title": "Settings",
  "battleMenu.audioOn": "Sound: on",
  "battleMenu.audioOff": "Sound: off",
  "battleMenu.resume": "Resume battle",
  "battleMenu.restart": "Restart battle",
  "battleMenu.exit": "Exit to map",
  "hud.priest": "Priest Lv {{level}}",
  "hud.grace": "Grace {{grace}}",
  "buddha.hud.monk": "Monk Lv {{level}}",
  "buddha.hud.karma": "Karma {{grace}}",
  "hud.buildings": "BUILDINGS",
  "hud.buildingsHidden": "{{n}} hidden",
  "hud.relics": "RELICS",
  "hud.relicsCount": "{{filled}} / {{total}}",
  "hud.actions": "ACTIONS",
  "hud.actionsHint": "hold [U/D/X]",
  "hud.actionCreate": "Create",
  "hud.actionDual": "Dual",
  "hud.actionCombine": "Combine",
  "hud.actionSanctify": "Sanctify",
  "hud.actionBomb": "Bomb",
  "hud.actionMelt": "Melt",
  "hud.actionRandom": "Random",
  "hud.speed0Title": "Stillness (0×) — pause the horde",
  "hud.speed1Title": "March (1×)",
  "hud.speed3Title": "Fervor (3×)",
  "hud.waveCallNext": "Wave {{n}} — call the next horror now",
  "hud.waveDone": "Wave {{n}} — finished",
  "hud.waveLocked": "Wave {{n}} — not yet",
  "hud.waveLabel": "WAVE",
  "hud.waveTitle": "WAVE {{index}}",
  "hud.waveSpawned": "{{spawned}}/{{total}} spawned",
  "hud.nextTitle": "NEXT",
  "hud.nextWaveDetails": "{{mobType}} · {{count}}\u00d7 HP {{hp}}",
  "hud.topbarWave": "W{{index}} \u00b7 {{spawned}}/{{total}}",
  "hud.topbarNext": "Next: {{mobType}}",
  "hud.prepSpace": "\u2328 Space or Wave 1 \u2014 begin the defense",
  "hud.buildChapel": "Chapel",
  "hud.buildWall": "Wall",
  "hud.buildAmplifier": "Amp-Monk",
  "hud.buildTrap": "Trap",
  "hud.buildShrine": "Shrine",
  "hud.createGemHint": "Press 1-8 to pick a color",

  "hud.upgradeCost": "Sanctification cost: {{cost}}",
  "hud.damage": "Damage: {{min}} - {{max}}",
  "hud.range": "Range: {{range}}",
  "hud.fireRate": "Rate: {{rate}}/s",
  // Map / World
  "map.title": "Sanctified Lands",
  "map.priestLv": "Priest Lv {{level}}",
  "map.xpProgress": "{{xp}} / {{next}} XP",
  "map.worldMap": "World Map",
  "map.launchCta": "Start Defense",
  "map.startDefense": "Start defense",

  // Settings
  "settings.title": "Defense Settings \u2014 {{field}}",
  "settings.hordeHp": "Horde HP",
  "settings.extraHordes": "Extra Hordes",
  "settings.trials": "Trials",
  "settings.resilientHorrors": "Resilient horrors (\u00d72.63 banish)",
  "settings.unholyVigor": "Unholy vigor (+50% HP on return)",
  "settings.graceMult": "Grace multiplier: \u00d7{{mult}}",
  "settings.begin": "Begin Defense",
  "settings.retreat": "Retreat [Esc]",

  // Result overlay
  "result.sanctified": "SANCTIFIED!",
  "result.fallen": "FALLEN",
  "result.clickRetreat": "Click to retreat",

  // Story
  "story.clickToContinue": "Click to continue...",
  "story.intro.panel1": "The Sanctified Lands flourished for centuries under the protection of the Sacred Relics. Peace and tranquility reigned in these lands...",
  "story.intro.panel2": "But one day the sky cracked open. From the blood-red rift, the legions of the Void poured out.",
  "story.intro.panel3": "You are the high priest, the last bastion of hope. Use the power of the relics to banish the evil!",
  "story.hollow_one.panel1": "In the depths of the corrupted forest, you found an ancient tome. It seems this invasion was foretold...",
  "buddha.story.intro.panel1": "Hold the line. Keep the temple still.",

  "summary.title.win": "SANCTIFIED!",
  "summary.title.lose": "FALLEN",
  "summary.kills": "Kills",
  "summary.banishes": "Breached",
  "summary.bombs": "Bombs cast",
  "summary.earlyCalls": "Early spawn calls",
  "summary.earlyLight": "Light from early spawns",
  "summary.duration": "Duration",
  "summary.xpEarned": "Grace earned",
  "summary.retreat": "Click to return to map",

  // Skills panel
  "skills.title": "Spiritual Gifts",
  "skills.grace": "Free: {{n}} / {{total}}",
  "skills.button": "Gifts [S]",
  "skills.lvMax": "Lv {{lv}}/{{max}}",
  "skills.val": "val: {{v}}",
  "skills.needLevel": "Lv{{req}} req",
  "skills.needPoints": "need {{cost}}pt",
  "skills.maxed": "MAX",
  "skills.costShort": "cost: {{cost}}",
  "skills.addTitle": "Add one level (Shift: add as many as possible)",
  "skills.refundTitle": "Refund one level (Shift: refund all)",

  // Skill names (27 skills, index 0-26)
  "skill.0": "More initial light",
  "skill.1": "Light replenish",
  "skill.2": "Banish light cost",
  "skill.3": "Lower creating/combining light cost",
  "skill.4": "Building cost",
  "skill.5": "Demolition",
  "skill.6": "Flame mastery",
  "skill.7": "Bloodbound mastery",
  "skill.8": "Violent explosions",
  "skill.9": "Storm mastery",
  "skill.10": "Chain hit mastery",
  "skill.11": "Amplifier power",
  "skill.12": "Cheaper light pool & unlock",
  "skill.13": "Dual gem mastery",
  "skill.14": "Triple gem mastery",
  "skill.15": "Slow mastery",
  "skill.16": "Armor tearing mastery",
  "skill.17": "Shrines",
  "skill.18": "Ether mastery",
  "skill.19": "Light gathering mastery",
  "skill.20": "Traps",
  "skill.21": "Damage",
  "skill.22": "Wild starter gem",
  "skill.23": "Gem deployment time",
  "skill.24": "Firing speed",
  "skill.25": "Range",
  "skill.26": "Badges to light",

  // Skill tooltips (Spiritual Gifts panel)
  "skill.desc.0": "More starting Light and a larger maximum Light pool when a battle begins.",
  "skill.desc.1": "Faster passive Light regeneration and more Light gained when you slay demons.",
  "skill.desc.2": "Reduces the Light cost to banish a demon (return it to its pit without killing it).",
  "skill.desc.3": "Reduces Light spent to create new relics and to combine relics in the forge.",
  "skill.desc.4": "Reduces Light cost to build chapels, walls, amplifiers, traps, and shrines.",
  "skill.desc.5": "Increases the Light refunded when you demolish a structure (above the base 50%).",
  "skill.desc.6": "Strengthens Flame (green): more damage over time while the flame burns.",
  "skill.desc.7": "Improves Fury / Bloodbound (red) critical hits so bursts hit harder.",
  "skill.desc.8": "Increases damage from violent explosions when relics detonate or splash.",
  "skill.desc.9": "Improves Storm (orange) strikes that hit multiple targets or splash nearby demons.",
  "skill.desc.10": "Improves Chain hit (lime): more jumps or stronger follow-up hits between targets.",
  "skill.desc.11": "Amplifiers boost nearby chapel firing speed more effectively.",
  "skill.desc.12": "Cheaper expansion of your Light reservoir and easier high-tier pool unlocks.",
  "skill.desc.13": "Dual-color relics are stronger and dual combinations are more efficient.",
  "skill.desc.14": "Higher chance that a newly created relic starts at an elevated grade.",
  "skill.desc.15": "Slow (purple) effects last longer or bite harder on fast demons.",
  "skill.desc.16": "Armor tearing (blue) strips more armor so follow-up shots hurt more.",
  "skill.desc.17": "Shrines discharge for more damage when their stored energy strikes demons.",
  "skill.desc.18": "Ether (cyan) shocks trigger more reliably or last longer on hit.",
  "skill.desc.19": "Light gathering (yellow) returns more Light from hits and beam harvests.",
  "skill.desc.20": "Trap chapels hit harder and their gem effects apply more strongly in the lane.",
  "skill.desc.21": "Flat increase to relic damage — every chapel benefits.",
  "skill.desc.22": "Your first random starter relic on the field rolls with extra power.",
  "skill.desc.23": "Less time to socket, move, or swap relics onto chapels during battle.",
  "skill.desc.24": "Chapels with the same relic shoot more often (lower time between volleys).",
  "skill.desc.25": "Increases chapel firing range so relics reach demons farther away.",
  "skill.desc.26": "Turns field completion marks into bonus starting Light on future battles.",

  // Gem short names (buttons, labels)
  "gem.name.Yellow": "Light",
  "gem.name.Orange": "Blast",
  "gem.name.Red": "Crit",
  "gem.name.Purple": "Slow",
  "gem.name.Green": "Poison",
  "gem.name.Blue": "Armor",
  "gem.name.Cyan": "Shock",
  "gem.name.Lime": "Chain",
  "gem.level": "Grade {{lvl}}",

  // Gem Effects (full description, for tooltips)
  "gem.effect.Yellow": "Light: +0.3×lvl mana per hit",
  "gem.effect.Orange": "Blast: 14% chance — full dmg to all nearby (radius 1 cell)",
  "gem.effect.Red": "Crit: 18% chance — ×2 damage",
  "gem.effect.Purple": "Slow: −30% speed for 2 sec",
  "gem.effect.Green": "Poison: 8×lvl dmg/sec for 2.5 sec",
  "gem.effect.Blue": "Armor: −0.18×lvl armor permanently",
  "gem.effect.Cyan": "Shock: 17% chance — stun for 1.5 sec",
  "gem.effect.Lime": "Chain: 25% chance — hit 2nd target at 60% dmg",

  // Stats panel
  "stats.title": "Mage Stats",
  "stats.button": "Stats [I]",
  "stats.summaryHeader": "Summary",
  "stats.timePlayed": "Time played",
  "stats.battles": "Battles",
  "stats.wins": "Wins",
  "stats.losses": "Losses",
  "stats.winRate": "Win rate",
  "stats.killsHeader": "Slayer",
  "stats.totalKills": "Demons slain",
  "stats.totalBanishes": "Demons breached",
  "stats.earlyHurryHeader": "Early horde calls",
  "stats.manaFromEarlyWaves": "Light from early spawns (career)",
  "stats.earlyWaveHurries": "Early spawn calls (career)",
  "stats.fieldsHeader": "Top fields",
  "stats.colField": "Field",
  "stats.colWins": "W",
  "stats.colFails": "L",
  "stats.colXp": "Best XP",

  // Tutorial overlay
  "tutorial.step1": "Click empty ground to build a chapel",
  "tutorial.step2": "Press 1\u20138 to invoke a relic",
  "tutorial.step3": "Click the chapel to install the relic",
  "tutorial.step4": "Press Space to begin the horde",
  "tutorial.step5": "Right-click to demolish (50% refund)",
  "tutorial.next": "Next \u2192",
  "tutorial.skip": "Skip",
  "tutorial.firstGem": "Create a gem first and place it into a chapel",

  // Achievements
  "stats.achievementsHeader": "Achievements",
  "stats.achievementsUnlocked": "{{n}} / {{total}} unlocked",
  "achievement.first_blood.name": "First Blood",
  "achievement.first_blood.desc": "Slay your first demon",
  "achievement.first_victory.name": "First Victory",
  "achievement.first_victory.desc": "Win your first battle",
  "achievement.slayer_100.name": "Slayer I",
  "achievement.slayer_100.desc": "Slay 100 demons",
  "achievement.slayer_1000.name": "Slayer II",
  "achievement.slayer_1000.desc": "Slay 1000 demons",
  "achievement.banisher_100.name": "Banisher",
  "achievement.banisher_100.desc": "Banish 100 demons to their pits",
  "achievement.battles_10.name": "Veteran",
  "achievement.battles_10.desc": "Start 10 battles",
  "achievement.battles_50.name": "Champion",
  "achievement.battles_50.desc": "Start 50 battles",
  "achievement.played_1h.name": "Dedicated",
  "achievement.played_1h.desc": "Play for 1 hour total",
  "achievement.fields_5.name": "Explorer",
  "achievement.fields_5.desc": "Sanctify 5 different lands",
  "achievement.fields_20.name": "Conqueror",
  "achievement.fields_20.desc": "Sanctify 20 different lands",
  "achievement.priest_level_5.name": "Adept",
  "achievement.priest_level_5.desc": "Reach priest level 5",
  "achievement.priest_level_10.name": "Master",
  "achievement.priest_level_10.desc": "Reach priest level 10",
  "achievement.early_wave_light_100.name": "Bold timing I",
  "achievement.early_wave_light_100.desc": "Gather 100 light from early wave spawns (career)",
  "achievement.early_wave_light_2000.name": "Bold timing II",
  "achievement.early_wave_light_2000.desc": "Gather 2,000 light from early wave spawns (career)",
  "achievement.early_wave_light_50000.name": "Bold timing III",
  "achievement.early_wave_light_50000.desc": "Gather 50,000 light from early wave spawns (career)",
  "achievement.early_wave_light_100000.name": "Bold timing IV",
  "achievement.early_wave_light_100000.desc": "Gather 100,000 light from early wave spawns (career)",
  "achievement.early_wave_calls_500.name": "Relentless herald",
  "achievement.early_wave_calls_500.desc": "Call 500 early spawns (career)",

  // Toast notifications — build errors
  "hud.fieldLocked": "Field is locked",
  "hud.fieldLockedHint": "Win an adjacent field first",

  // Toast notifications
  "toast.levelUp": "Priest Level {{level}}!",
  "toast.levelUpSubtitle": "Your spiritual power grows",
  "toast.giftsUnlocked": "New gifts unlocked",
  "toast.giftUnlockedSubtitle": "{{name}} - {{points}} Grace available",
  "toast.giftsUnlockedSubtitle": "{{count}} new gifts - {{points}} Grace available",
  "toast.giftsAvailable": "Grace available",
  "toast.giftsAvailableSubtitle": "{{points}} point(s) to spend in Gifts",
  "toast.earlyWaveManaTitle": "+{{n}} light",
  "toast.earlyWaveManaSubtitle": "Early horde call",

  // Locale toggle — label shows where you'll switch TO
  "locale.toggle": "EN",

  // Mobile portrait overlay
  "mobile.rotateDevice": "Please rotate your device",
};
